import React, { useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref(s)
 * @param refs - Single ref or array of refs to check if click is outside
 * @param callback - Function to call when click is outside all refs
 */
export const useClickOutside = (
  refs:
    | React.RefObject<HTMLElement | null>
    | React.RefObject<HTMLElement | null>[],
  callback: (event: React.MouseEvent) => void
): void => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element(s)
     */
    const handleClickOutside: React.MouseEventHandler = (event) => {
      const refsArray = Array.isArray(refs) ? refs : [refs];
      const isOutside = refsArray.every(
        (ref) => ref.current && !ref.current.contains(event.target as Node)
      );

      if (isOutside) {
        callback(event);
      }
    };

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside as any);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside as any);
    };
  }, [refs, callback]);
};
